import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase, supabaseEnabled } from '../lib/supabase';

export default function AuthCallback() {
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      if (supabaseEnabled && supabase) {
        // Supabase auto-detects the session from the URL hash.
        await supabase.auth.getSession();
      }
      nav('/', { replace: true });
    })();
  }, [nav]);
  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100dvh' }}>
      <div className="sc" style={{ color: 'var(--fg-dim)' }}>signing you in…</div>
    </div>
  );
}
